import React, { useState, useEffect } from "react";
import {COLOR_GRAY_DASHBOARD_BACKGROUND} from "../constants/general-constants";

export default function CalendarIntensityMonth({calendarMonth}) {
  
  
  const [name, setName] = useState("");
  const [calendarWeeks, setCalendarWeeks] = useState([]);

  useEffect(() => {
  	console.log(calendarMonth);
   if(calendarMonth && calendarMonth.calendarWeeks){
   	setName(calendarMonth.name);
   	setCalendarWeeks(calendarMonth.calendarWeeks);
   }
  }, [calendarMonth]);
  
  const getDayBackground = (day) => {
    if(day.isValid === true){
      if(day.intensity === 0){
        return "rgba(255,255,255,0.06)";
      }
      else{
        return "rgba(0, 120, 255, " + day.intensity + ")";
      }
    }
    else{
      return "rgba(255,255,255,0.04)";
    }
  };
  
  const getDayBoxShadow = (day) => {
    if(day.isValid === true && day.intensity > 0){
      return "0 0 6px rgba(0,120,255,0.45)";
    }
    return "none";
  };

 
  const thisContainer = {
    display: "flex",
    flexDirection: "column",
    width: "calc(100% - 20px)",
    margin: "10px",
	marginBottom:'0px',
    background: "linear-gradient(180deg, #3a3d42 0%, #2c2f33 100%)",
    borderRadius: "10px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.35)",
    border: "1px solid rgba(255,255,255,0.08)",

    overflow: "hidden"
  };

  const titleRow = {
    display: "flex",
    width: "100%",
    height: "28px",
    background: "linear-gradient(180deg, #44484e 0%, #35383d 100%)",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "14px",
    fontWeight: "600",
    color: "#f0f0f0",
    borderBottom: "1px solid rgba(255,255,255,0.08)",
    letterSpacing: "0.4px"
  };

  const dayRow = {
    display: "flex",
    width: "100%",
    height: "26px",
    background: "rgba(255,255,255,0.05)",
    borderBottom: "1px solid rgba(255,255,255,0.06)"
  };

  const dayContainer = {
    display: "flex",
    width: "14%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    fontWeight: "600",
    color: "#d0d0d0"
  };

  const days = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

  const dayDisplay = days.map((item, index) => (
    <div style={dayContainer} key={index}>
      {item}
    </div>
  ));
  
  
  const weekRow = {
    display: "flex",
    width: "100%",
    minHeight: "28px",
    marginTop: "2px",
    paddingLeft: "4px",
    paddingRight: "4px"
  };
  
  const dayPanel = {
    display: "flex",
    width: "calc(15% - 4px)",
    height: "24px",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "11px",
    color: "#f0f0f0",
    marginRight: "4px",
    borderRadius: "4px",
    backgroundColor: "rgba(255,255,255,0.06)",
    transition: "background-color 0.15s ease"
  };
  
 
  
  const getDayCursor = (day) => {
  	if(day.isValid === true){
			return "pointer"  		
  	}
  	else{
  		return "default";
  	}
  }
  
  const weekDisplay = calendarWeeks.map((item, index) =>
  	<div style={weekRow}>
  		{item.calendarDays.map((day, index) =>
			<div
			  style={{
			    ...dayPanel,
			    backgroundColor: getDayBackground(day),
			    cursor: getDayCursor(day),
			    boxShadow: getDayBoxShadow(day),
			    transition: "transform 0.15s ease, box-shadow 0.15s ease"
			  }}
			  onMouseEnter={(e) => {
			    if(day.isValid === true){
			      e.currentTarget.style.transform = "translateY(-1px)";
			      e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.35)";
			    }
			  }}
			  onMouseLeave={(e) => {
			    if(day.isValid === true){
			      e.currentTarget.style.transform = "translateY(0)";
			      e.currentTarget.style.boxShadow = getDayBoxShadow(day);
			    }
			  }}
			>
			  {day.dateNumber}
			</div>
  		)}
  	</div>
  );

  return (
    <div style={thisContainer}>
      <div style={titleRow}>{name}</div>
      <div style={dayRow}>{dayDisplay}</div>
      {weekDisplay}
    </div>
  );
}
